export interface Props {
  text: string;
}

export const PickerHeader: React.FC<Props> = (props) => {
  return (
    <div
      style={{
        height: '100%',
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
          color: 'white',
          writingMode: 'vertical-lr',
          letterSpacing: '0.05em',
        }}
      >
        {props.text}
      </div>
    </div>
  );
};
